import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet'; 


/* CONTENT ALL PAGES */
import Header from './components/ui/header';
import Footer from './components/ui/footer';
import FaviconIcon from './components/image/favicon.ico';

/* HEADER PAGES */
import HomePage from './components/home';
import ServicesPage from './components/home'; /* './components/services'; */

/* FOODER PAGES */
import MentionsPage from './components/mentions';
import PolitiquePage from './components/politique';
import CookiesPage from './components/cookies';


const SevRemorque = () => {
  const [currentPage, setCurrentPage] = useState('home');

  const navigateTo = (page) => {
      setCurrentPage(page);
  };

  // Observateur CurrentPage
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage />;
      case 'services':
        return <ServicesPage />;
      case 'mentions':
        return <MentionsPage />;
      case 'politique':
        return <PolitiquePage />;
      case 'cookies':
        return <CookiesPage />;
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="bg-gray-100 min-h-screen">
      <Helmet>
        <title>Sev Remorque - Remorquage et Enlèvement de Véhicules</title>
        <meta
          name="description"
          content="Services de remorquage et enlèvement de véhicules en Occitanie. Assistance 24h/7j pour un service rapide et efficace."
        />
        <meta
          name="keywords"
          content="remorquage, enlèvement véhicule, épaviste gratuit, assistance 24h/24 7j/7, Occitanie"
        />
        <meta name="google-site-verification" content="eRz8zUqTDmgg0Lp_ubugQAw2XycdfCPZufWLeMWwM24" />
        <link rel="canonical" href="https://www.dépannage-occitanie.com" />
        <meta property="og:title" content="Sev Remorque - Remorquage et Enlèvement de Véhicules" />
        <meta
          property="og:description"
          content="Services de remorquage et enlèvement de véhicules en Occitanie. Assistance 24h/7j pour un service rapide et efficace."
        />
        <meta property="og:url" content="https://www.dépannage-occitanie.com" />
        <meta property="og:type" content="website" />
        <meta name="robots" content="index, follow" />
        <link rel="icon" href={FaviconIcon} />
      </Helmet>
      <Header navigateTo={navigateTo} currentPage={currentPage} />
      <main>{renderPage()}</main>
      <Footer navigateTo={navigateTo} currentPage={currentPage} />
    </div>
  );
};


export default SevRemorque;